<template> 
	<article class="telegram-block" v-if="active">
		<div class="telegram-block__popup">
			<button class="telegram-block__popup-close">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					@click="hideBlock"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M4 4.00005C4.39053 3.60952 5.02369 3.60952 5.41422 4.00005L11.7783 10.3642L18.1421 4.00034C18.5327 3.60981 19.1658 3.60981 19.5564 4.00034C19.9469 4.39086 19.9469 5.02403 19.5564 5.41455L13.1925 11.7784L19.5564 18.1422C19.9469 18.5327 19.9469 19.1659 19.5564 19.5564C19.1658 19.9469 18.5327 19.9469 18.1421 19.5564L11.7783 13.1926L5.41422 19.5567C5.02369 19.9472 4.39053 19.9472 4 19.5567C3.60948 19.1662 3.60948 18.533 4 18.1425L10.3641 11.7784L4 5.41426C3.60948 5.02374 3.60948 4.39057 4 4.00005Z"
						fill="#252628"
					/>
				</svg>
			</button>
			<img :src="image" class="telegram-block__popup-qr" />
			<p class="telegram-block__popup-text" v-html="text"></p>
			<div class="telegram-block__popup-block">
				<img
					class="telegram-block__popup-block-icon"
					src="/static/dist/v2/img/telegram-icon.webp"
				/>
				<p class="telegram-block__popup-text telegram-block__popup-text_mobile" v-html="textMobile"></p>
			</div>

			<a class="telegram-block__popup-link-button" target="_blank" :href="link">
				Подписаться
			</a>
		</div>
	</article>
</template>
<script>
export default {
	name: 'TelegramBlock',
	props: ['type'],
	data() {
		return {
			active: false,
			image: '/static/dist/v2/img/qr-telegram-life.webp',
			link: 'https://t.me/domrf_life',
			text: 'Телеграм канал',
			textMobile: '',
		}
	},
	mounted() {
		if (!this.getCookie('telegram-domrf')) {
			this.active = true
		}

		switch (conf.qr_code_type) {
			
			case 'for-regions':
				this.image = '/static/dist/v2/img/telegram-x2-sreda.webp'
				this.link = 'https://t.me/sredaforlife'
				this.text = `Подпишитесь на наш <br />
				<a
					class="telegram-block__popup-link"
					target="_blank"
					href="https://t.me/sredaforlife"
				>Телеграм канал Среда для жизни</a>
				и будьте в курсе <br />
				последних новостей`
				this.textMobile = `Подпишитесь на наш Телеграм <br /> канал Среда для жизни и будьте в курсе последних новостей`
				break
			case 'it-vacancies':
				this.image = '/static/dist/v2/img/telegram-x2-tech.webp'
				this.link = 'https://t.me/domrf_tech'
				this.text = `Подпишитесь на наш <br />
				<a
					class="telegram-block__popup-link"
					target="_blank"
					href="https://t.me/domrf_tech"
				>Телеграм канал ДОМ.РФ ТЕХ</a>
				и будьте в курсе <br />
				последних новостей`
				this.textMobile = `Подпишитесь на наш Телеграм <br /> канал ДОМ.РФ ТЕХ и будьте в курсе последних новостей`
				break
			case 'analytics':
				this.image = '/static/dist/v2/img/telegram-x2-analytics.webp'
				this.link = 'https://t.me/+f8BRaLYLU4ZkNGEy'
				this.text = `Подпишитесь на наш <br />
				<a
					class="telegram-block__popup-link"
					target="_blank"
					href="https://t.me/+f8BRaLYLU4ZkNGEy"
				>Телеграм канал Аналитика в квадрате</a>
				и будьте в курсе <br />
				последних новостей`
				this.textMobile = `Подпишитесь на наш Телеграм <br /> канал Аналитика в квадрате и будьте в курсе последних новостей`
				break
			case 'urban/polls/magas-sunja':
				this.image = '/static/dist/v2/img/telegram-x2-magas.webp'
				this.link = 'https://t.me/magas_sunja_agglomeration'
				this.text = `Подпишитесь на <a class="telegram-block__popup-link" target="_blank" href="https://t.me/magas_sunja_agglomeration">канал</a> для прямой связи с разработчиками проекта`
				this.textMobile = `Подпишитесь на <a class="telegram-block__popup-link" target="_blank" href="https://t.me/magas_sunja_agglomeration">канал</a> для <br>прямой связи с разработчиками проекта`
				break
			case 'urban/polls/usolye-sibirsky':
				this.image = '/static/dist/v2/img/telegram-x2-usolye.webp'
				this.link = 'https://t.me/mp_u_s'
				this.text = `Следите за анонсами мероприятий в <a class="telegram-block__popup-link" target="_blank" href="https://t.me/mp_u_s">телеграм-канале</a>`
				this.textMobile = `Следите за анонсами <br>мероприятий в <a class="telegram-block__popup-link" target="_blank" href="https://t.me/mp_u_s">телеграм-канале</a>`
				break
			default:
				this.image = '/static/dist/v2/img/telegram-x2-life.webp'
				this.link = 'https://t.me/domrf_life'
				this.text = `Подпишитесь на наш <br />
				<a
					class="telegram-block__popup-link"
					target="_blank"
					href="https://t.me/domrf_life"
				>Телеграм канал</a>
				и будьте в курсе <br />
				последних новостей`
				this.textMobile = `Подпишитесь на наш Телеграм <br> канал  и будьте в курсе последних новостей`
		}
	},
	methods: {
		hideBlock() {
			this.setCookie('telegram-domrf', true, 1)
			this.active = false
		},
		setCookie(key, value, days) {
			const expires = new Date()
			expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
			document.cookie = `${key}=${value};path=/;expires=${expires.toUTCString()}`
		},
		getCookie(key) {
			const keyValue = document.cookie.match(`(^|;) ?${key}=([^;]*)(;|$)`)
			return keyValue ? keyValue[2] : null
		},
	},
}
</script>
